import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'simple-fullwidth-1-page-scroll',
    templateUrl  : './fullwidth-1.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SimpleFullwidth1PageScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
